export * from './fetch'

export const TRN_BIOSEC_RESET = 'TRN_BIOSEC_RESET'

export const biosecurityReset = () => ({
  payload: null,
  type: TRN_BIOSEC_RESET,
})
